import { isEmptyRequiredValue } from 'components/RequireConfig/config'

export const PATIENT_REGISTER_REQUIRE_FIELDS = [
  { key: 'patient.militaryNumber', label: 'เลขกลาโหม' },
  { key: 'patient.privateSoldierId', label: 'เลขประจำตัวพลทหาร' },
  { key: 'patient.navyPatientTypeId', label: 'ประเภทผู้รับบริการ' },
  { key: 'patient.navyPatientGroupId', label: 'กลุ่มผู้รับบริการ' },
  { key: 'regiment.mainRegiment', label: 'สังกัดหลัก' },
  { key: 'regiment.subRegiment', label: 'สังกัดรอง' },
  { key: 'person.citizenId', label: 'เลขบัตรประชาชน' },
  { key: 'patient.nmdHn', label: 'HN (NMD)' },
  { key: 'person.prefixName', label: 'คำนำหน้าชื่อไทย' },
  { key: 'person.firstName', label: 'ชื่อไทย' },
  { key: 'person.lastName', label: 'นามสกุลไทย' },
  { key: 'person.middleName', label: 'ชื่อกลางไทย' },
  { key: 'person.prefixNameEn', label: 'คำนำหน้าชื่ออังกฤษ' },
  { key: 'person.firstNameEn', label: 'ชื่ออังกฤษ' },
  { key: 'person.lastNameEn', label: 'นามสกุลอังกฤษ' },
  { key: 'person.middleNameEn', label: 'ชื่อกลางอังกฤษ' },
  { key: 'person.genderId', label: 'เพศ' },
  { key: 'person.sexualOrientation', label: 'Sexual Orientation' },
  { key: 'person.aliasName', label: 'ชื่อเล่น' },
  { key: 'person.birthDate', label: 'วันเกิด' },
  { key: 'person.birthTime', label: 'เวลาเกิด' },
  { key: 'person.maritalStatusId', label: 'สภาพสมรส' },
  { key: 'person.occupationCode', label: 'อาชีพ' },
  { key: 'person.communicationLanguageCode', label: 'ภาษาหลัก' },
  { key: 'person.citizenshipCode', label: 'เชื้อชาติ' },
  { key: 'person.nationalityCode', label: 'สัญชาติ' },
  { key: 'person.religionCode', label: 'ศาสนา' },
  { key: 'patient.bloodGroupCode', label: 'หมู่เลือด' },
  { key: 'patient.bloodGroupRh', label: 'RH' },
  { key: 'person.phoneNumber', label: 'เบอร์โทรศัพท์' },
  { key: 'person.email', label: 'E-mail' },
  { key: 'patient.referralChannelId', label: 'ช่องทางที่รู้จักโรงพยาบาล' },
  { key: 'patient.patientClassId', label: 'Patient Class' },
  { key: 'person.cardExpiredDate', label: 'วันหมดอายุบัตร' },
  { key: 'person.passportNumber', label: 'เลข Passport' },
  { key: 'person.foreignCitizenId', label: 'เลขต่างด้าว' },
  { key: 'patient.physicalDescription', label: 'อัตลักษณ์/ตำหนิรูปพรรณ' },
  { key: 'person.servicePreference', label: 'Service Note' },
]

export const PATIENT_REGISTER_DEFAULT_REQUIRE_CONFIG = {
  'person.citizenId': true,
  'person.prefixName': true,
  'person.firstName': true,
  'person.lastName': true,
}

export const getPatientRegisterRequiredFieldErrors = ({
  form,
  isRequired = (key) => Boolean(PATIENT_REGISTER_DEFAULT_REQUIRE_CONFIG[key]),
  isVisible = () => true,
}) => PATIENT_REGISTER_REQUIRE_FIELDS
  .filter(({ key }) => {
    if (!isRequired(key) || !isVisible('general.' + key)) return false
    if (key === 'patient.navyPatientGroupId' && !form.patient.navyPatientTypeId) return false
    if (key === 'patient.physicalDescription' &&
      !Number(form.patient.isAnonymousPerson) && !form.patient.physicalDescription) return false
    const [group, name] = key.split('.')
    return isEmptyRequiredValue(form[group]?.[name])
  })
  .map(({ label }) => 'กรุณาระบุ' + label)
